<div class="search-wrapper">
  <div class="search-container">
    <div class="search-bar">
      <span class="search-icon" [innerHTML]="ICONS.searchIcon | safeHtml"></span>
      <input
        type="text"
        id="search"
        class="search-input"
        (keydown.enter)="onSearch()"
        [(ngModel)]="searchContent"
        placeholder="Type to search here..."
      />
    </div>
    <div *ngIf="searchContent" class="button-container">
      <button class="search-btn" (click)="onSearch()">Click here or press enter to search</button>
    </div>
  </div>
  <button type="button" class="btn-close text-reset" (click)="onClose()">
    <span class="btn-close text-reset close-icon" [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
  </button>
</div>
